<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="green">
                            <v-toolbar-title class="my-0 py-0">Depósitos / Departamentos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="green lighten-4" class="py-0 my-0">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="2" md="4">
                                    <v-text-field color="green darken-2" dense v-model="codigo"
                                        label="Código"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="10" md="8">
                                    <v-text-field color="green darken-2" dense v-model="detalle"
                                        label="Depósito"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="5">
                                    <v-text-field color="green darken-2" dense v-model="responsable"
                                        label="Responsable"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="5">
                                    <v-text-field color="green darken-2" dense v-model="direccion"
                                        label="Dirección"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <v-select item-color="green" color="green darken-2" dense v-model="activo"
                                        :items="estados" label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="green lighten-4" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        valid: false,
        lazy: false,
        codigo: "",
        detalle: "",
        responsable: "",
        direccion: "",
        deshabilitar: false,
        activo: "A",
        estados: [
            { nombre: 'Activo', valor: 'A' },
            { nombre: 'Inactivo', valor: 'I' },
        ],
    }
    ),
    props: ["visible", "codgral"],
    computed: {

        fecha() {
            return this.formatDate(this.date)
        },
        show: {
            get() {
                this.vaciarModels();
                this.deshabilitar = false;
                console.log("codigo " + this.codgral)
                if (this.codgral != null) {
                    this.cargarDeposito();
                    this.codigo = this.codgral;
                }

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarDeposito() {
            const codigo = this.codgral;
            let self = this;
            axios
                .get("/SSGG/CargarDepositos?", {
                    params: {
                        filtrocodigo: codigo,
                        filtroestado: "",
                        filtrodetalle: "",
                    },
                })
                .then((response) => {
                    console.log(response.data)
                    self.detalle = response.data[0].detalle;
                    self.direccion = response.data[0].direccion;
                    self.responsable = response.data[0].responsable;
                    self.activo = response.data[0].activo;
                })
                .catch((error) => {

                    console.log(error);
                });
        },

        vaciarModels() {
            this.codigo = "";
            this.detalle = "";
            this.responsable = "";
            this.direccion = "";
            this.activo = "";
            // this.$router.push({ name: "EquiposDepositos" });
        },

        guardar() {
            this.$swal({
                title: "Guardar Depósito",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        codigo: this.codigo,
                        detalle: this.detalle,
                        responsable: this.responsable,
                        direccion: this.direccion,
                        activo: this.activo,
                    };

                    let self = this;
                    axios
                        .post("/SSGG/GuardarDeposito", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.showAlert({
                                icon: "success",
                                title: "Depósito guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    }
}
</script>